import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Examples } from "@/components/Examples";
import { StyleSelector, StyleId } from "@/components/StyleSelector";
import { UploadFlow } from "@/components/UploadFlow";
import { Pricing } from "@/components/Pricing";
import { Testimonials } from "@/components/Testimonials";
import { HowItWorks } from "@/components/HowItWorks";
import { Footer } from "@/components/Footer";
import { GdprBanner } from "@/components/GdprBanner";
import { SEO } from "@/components/SEO";

const Index = () => {
  const [style, setStyle] = useState<StyleId>("cartoon");

  return (
    <div className="min-h-screen">
      <SEO
        title="PunchInk – AI Cartoon Portrait Generator"
        description="Transform any photo into stunning AI cartoon art. 9 styles: Neon, Ghibli, Comic Book, Oil Painting and more. Instant HD results from $4.99."
        path="/"
        type="product"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Punchink Cartoon & Caricature Portrait",
          description:
            "Transform any photo into a stunning cartoon & caricature portrait. Choose from 9 styles: Neon, Ghibli, Comic Book, Oil Painting and more. HD quality, instant results.",
          image: "https://punchink.com/og-image.jpg?v=20260518",
          brand: { "@type": "Brand", name: "PunchInk" },
          url: "https://punchink.com/",
          aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "500" },
          offers: [
            { "@type": "Offer", name: "Single Punch", price: "4.99", priceCurrency: "USD", availability: "https://schema.org/InStock", url: "https://punchink.com/" },
            { "@type": "Offer", name: "Punch Pack", price: "9.99", priceCurrency: "USD", availability: "https://schema.org/InStock", url: "https://punchink.com/" },
            
          ],
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Examples />
        <StyleSelector selected={style} onSelect={setStyle} />
        <UploadFlow style={style} />
        <HowItWorks />
        <Pricing />
        <Testimonials />
      </main>
      <Footer />
      <GdprBanner />
    </div>
  );
};

export default Index;
